var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"text"},[_vm._v("沪ICP备2023004056号 "),_c('a',{staticClass:"link",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("工信部备案https://beian.miit.gov.cn/")])])])
}]

export { render, staticRenderFns }